import React, { Component } from 'react'
import autoBind from 'react-autobind'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router'
import { Button, Container, Grid, Segment } from 'semantic-ui-react'
import _ from 'lodash'

import Attendance from './attendance'
import Evaluation from './evaluation'
import Exercises from './exercises'
import { tr } from '../../helpers/languages'
import { send } from '../../helpers/requests'
import NextReminder from './next-reminder'
import Notes from './notes'
import Reminder from './reminder'
import { actions as messages } from '../../store/actions/messages'
import { actions as participants } from '../../store/actions/participants'
import ErrorModal from '../error-modal'

class ParticipantSession extends Component {
    constructor (props) {
        super(props)
        this.state = {
            editable: {
                attendance: props.status !== 'completed',
                notes: props.status !== 'completed',
                reminder: props.status !== 'completed',
                evaluation: props.status !== 'completed'
            },
            doNotDisturb: false
        }
        autoBind(this)
    }

    componentDidMount () {
        if (this.props.userTokens.accessToken.token) {
            const participantDetails = this.props.participant_session_details[this.props.match.params.id]
            const session = participantDetails ? participantDetails[this.props.id] : undefined
            if (!session || !session.attendance) {
                // Fetch the session.
                this.fetchSession()
            }
        }
    }

    componentWillReceiveProps (nextProps) {
        if (nextProps.userTokens.accessToken.token !== this.props.userTokens.accessToken.token) {
            const participantDetails = this.props.participant_session_details[this.props.match.params.id]
            const session = participantDetails ? participantDetails[this.props.id] : undefined
            if (!session || !session.attendance) {
                // Fetch the session.
                this.fetchSession()
            }
        }
    }

    // Fetches the participant's session with the given ID.
    fetchSession () {
        // eslint-disable-next-line no-console
        console.log('Fetch session.')
        send({
            method: 'GET',
            tokens: this.props.userTokens,
            url: `/patients/${this.props.match.params.id}/sessionprogram/${this.props.id}`
        })
            .then((response) => {
                // eslint-disable-next-line no-console
                console.log('Fetched session.')
                let data = response.data
                data["id"] = this.props.id
                data["status"] = this.props.status
                const participant_a0 = this.props.match.params.id
                const module_id = this.props.id
                this.props.setParticipantSessionDetails({participant_a0, module_id, value: data})
            })
            .catch((error) => {
                // Failed to fetch session.
                // eslint-disable-next-line no-console
                console.error('Failed to fetch session.', error)
                // Hide the error.
            })
    }

    // Updates the participant's session with the given ID.
    updateSession () {
        // eslint-disable-next-line no-console
        console.log('Update session.')
        const session = this.props.participant_session_details[this.props.match.params.id][this.props.id] || {}
        if (this.areSessionFieldsCompleted(session)) {
            send({
                method: 'PUT',
                tokens: this.props.userTokens,
                data: {
                    notes: session.notes || '',
                    attendance: session.attendance || {},
                    appearance: session.appearance || {},
                    reminder: session.reminder || '',
                    evaluation: session.evaluation || {},
                    exercises: session.exercises || []
                },
                url: `/patients/${this.props.match.params.id}/sessionprogram/${this.props.id}`
            })
                .then((_response) => {
                    // eslint-disable-next-line no-console
                    console.log('Updated session.')
                    this.setState({
                        doNotDisturb: false,
                        editable: {
                            attendance: this.props.status !== 'completed',
                            notes: this.props.status !== 'completed',
                            reminder: this.props.status !== 'completed',
                            evaluation: this.props.status !== 'completed'
                        }
                    })
                    this.props.message({ type: 'info', text: tr('YOUR_CHANGES_HAVE_BEEN_SAVED') })
                    // Fetch the session.
                    this.fetchSession()
                })
                .catch((error) => {
                    // Failed to update session.
                    // eslint-disable-next-line no-console
                    console.error('Failed to update session.', error)
                    this.setState({ doNotDisturb: false })
                    this.props.message({ type: 'error', text: tr('FAILED_TO_SAVE_CHANGES') })
                })
        } else {
            this.setState({
                doNotDisturb: false,
                shouldShowModal: true
            })
            console.log('lol')
        }
    }

    hideModal () {
        this.setState({ shouldShowModal: false })
    }

    // Saves the participant's session.
    saveSession () {
        // Do not disturb.
        if (this.state.doNotDisturb) {
            return
        }

        // Put the do not disturb sign.
        this.setState({ doNotDisturb: true })

        // Update the session.
        this.updateSession()
    }

    areSessionFieldsCompleted (session) {
        let areCompleted

        if (session.attendance.status === 'ontime' || session.attendance.status === 'delayed') {
            areCompleted = !!(!_.isEmpty(session.appearance) && !_.isEmpty(session.attendance) && !_.isEmpty(session.evaluation) && session.evaluation.compliance && session.evaluation.emotional_awareness && session.evaluation.emotional_state && session.evaluation.progress)
        } else {
            areCompleted = !!(!_.isEmpty(session.attendance))
        }

        return areCompleted
    }

    // Changes the value of some field.
    changeValue (field, value) {
        const parts = field.split('.')
        this.setState({
            session: {
                ...this.state.session,
                [parts[0]]: parts.length === 1 ? value : { ...(this.state.session[parts[0]] || {}), [parts[1]]: value }
            }
        })
    }

    // Toggles the editing of the given section.
    toggleEditing (section) {
        this.setState({ editable: { ...this.state.editable, [section]: !this.state.editable[section] } })
    }

    render () {
        const participantDetails = this.props.participant_session_details[this.props.match.params.id]
        const session = participantDetails ? participantDetails[this.props.id] : undefined
        if (!session || !session.attendance) {
            return null
        }

        return (
            <Container className={`participant-session ${this.props.status}`}>
                <Segment className='session-buttons-top right aligned'>
                    <Button className='save' onClick={(_e) => { this.saveSession() }}>{tr('SAVE')}</Button>
                </Segment>
                <Grid>
                    {
                        session.previous_reminder && (
                            <Grid.Row columns={1}>
                                <Grid.Column>
                                    <Reminder
                                        session={session}
                                    />
                                </Grid.Column>
                            </Grid.Row>
                        )
                    }
                    <Grid.Row columns={2}>
                        <Grid.Column>
                            <Attendance
                                session={session}
                                onChangeValue={this.changeValue}
                                editable={this.state.editable.attendance}
                                onToggleEditing={() => { this.toggleEditing('attendance') }}
                            />
                        </Grid.Column>
                        <Grid.Column>
                            <Notes
                                session={session}
                                onChangeValue={this.changeValue}
                                editable={this.state.editable.notes}
                                onToggleEditing={() => { this.toggleEditing('notes') }}
                            />
                        </Grid.Column>
                    </Grid.Row>
                    {
                        this.props.id !== '16' && (
                            <Grid.Row columns={1}>
                                <Grid.Column>
                                    <Exercises
                                        session={session}
                                        onChangeValue={this.changeValue}
                                    />
                                </Grid.Column>
                            </Grid.Row>
                        )
                    }
                    <Grid.Row columns={1}>
                        <Grid.Column>
                            <Evaluation
                                session={session}
                                goal={this.props.goal}
                                onChangeValue={this.changeValue}
                                editable={this.state.editable.evaluation}
                                onToggleEditing={() => { this.toggleEditing('evaluation') }}
                            />
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row columns={1}>
                        <Grid.Column>
                            <NextReminder
                                session={session}
                                onChangeValue={this.changeValue}
                                editable={this.state.editable.reminder}
                                onToggleEditing={() => { this.toggleEditing('reminder') }}
                            />
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
                <Segment className='session-buttons-bottom right aligned'>
                    <Button className='save' onClick={(_e) => { this.saveSession() }}>{tr('SAVE')}</Button>
                </Segment>
                {
                    this.state.shouldShowModal &&
                    <ErrorModal
                        text={tr('COMPLETE_FIELDS_TO_CONTINUE')}
                        onOk={this.hideModal}
                        onClose={this.hideModal}
                    />
                }
            </Container>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        goal: state.participants.participant.goal,
        language: state.settings.language,
        timezone: state.settings.timezone,
        userTokens: state.users.userTokens,
        participant_session_details: state.participants.participant_session_details
    }
}

const mapDispatchToProps = (dispatch) => {
    const _messages = bindActionCreators(messages, dispatch)
    const _participants = bindActionCreators(participants, dispatch)
    return {
        message: _messages.message,
        setParticipantSessionDetails: _participants.setParticipantSessionDetails
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ParticipantSession))



// WEBPACK FOOTER //
// ./src/components/participant-session/index.js